
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical_institution/introduction",
      function () {
        return require("private-next-pages/medical_institution/introduction/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical_institution/introduction"])
      });
    }
  